<template>
  <div class="p-4 service-lib-error-report">
    <button class="bg-transparent text-primary border-0 p-0 no-outline font-weight-bold" @click.prevent="handleVisibilityChange(true)">
      <b-icon icon="exclamation-triangle" class="mr-2" />
      {{ translatedLabel('reportButton', 'servicelibrary_Report') }}
    </button>
    <b-sidebar
      v-if="!isMobile"
      v-model="isVisible"
      no-header
      right
      shadow
      class="service-lib-drawer"
      backdrop
      bg-variant="white"
      width="544px"
    >
      <ServiceLibraryErrorReportFormWrapper @handleVisibilityChange="handleVisibilityChange" />
    </b-sidebar>

    <b-modal
      v-if="isMobile"
      v-model="isVisible"
      hide-header
      hide-footer
      body-class="service-lib-modal"
    >
      <ServiceLibraryErrorReportFormWrapper @handleVisibilityChange="handleVisibilityChange" />
    </b-modal>

    <ServiceLibraryErrorReportFormAlert v-if="getServiceLibraryFormSubmitted"
                                        :is-error="getServiceLibraryFormError"
                                        :success-msg="translatedLabel('formSuccessMsg', 'servicelibrary_Report')"
                                        :error-msg="translatedLabel('formErrorMsg', 'servicelibrary_Report')"
                                        @handleClose="handleAlert"
    />
  </div>
</template>

<script>
import ServiceLibraryErrorReportFormWrapper from '@/components/ServiceLibrary/ServiceLibraryErrorReportFormWrapper.vue'
import ServiceLibraryErrorReportFormAlert from '@/components/ServiceLibrary/ServiceLibraryErrorReportFormAlert.vue'
import {mapGetters} from 'vuex'

export default {
  conceptName: ['ServiceLibrary'],
  components: {
    ServiceLibraryErrorReportFormAlert,
    ServiceLibraryErrorReportFormWrapper
  },
  data() {
    return {
      isVisible: false,
      isMobile: window.matchMedia('(max-width: 768px)').matches
    }
  },
  computed: {
    ...mapGetters({
      getServiceLibraryFormSubmitted: 'servicelibrary/getServiceLibraryFormSubmitted',
      getServiceLibraryFormError: 'servicelibrary/getServiceLibraryFormError'
    })
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.isMobile = window.matchMedia('(max-width: 768px)').matches
    },
    handleVisibilityChange(v) {
      this.isVisible = v
    },
    handleAlert() {
      this.$store.commit('servicelibrary/saveServiceLibraryFormSubmitted', false)
      this.$store.commit('servicelibrary/saveServiceLibraryFormError', false)
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/z-index';

.no-outline {
  outline: none !important;

  &:hover {
    opacity: .8;
  }
}

.service-lib-drawer, .service-lib-modal {
  z-index: $zindex-tooltip + 11 !important;

  .captioned-text {
    font-size: .75rem;
  }

  .service-lib-round-btn {
    min-width: 3rem;
    min-height: 3rem;
    border-radius: 100%;
    color: black !important;
  }
}
</style>
